import { FC } from 'react';
import { Check, X, DollarSign } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';

export const PricingSection: FC = () => {
  const navigate = useNavigate();

  const features = [
    "Acceso a lecciones básicas",
    "Juegos educativos",
    "Seguimiento de progreso",
    "Comunidad de aprendizaje",
    "Lecciones avanzadas",
    "Juegos premium",
    "Asesoría personalizada",
    "Contenido exclusivo"
  ];

  const originalPrice = 50;
  const discountedPrice = 19;
  const discountPercentage = Math.round(((originalPrice - discountedPrice) / originalPrice) * 100);

  return (
    <section className="py-12 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-primary mb-4">
            Planes diseñados para el aprendizaje
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            Elige el plan que mejor se adapte a las necesidades de aprendizaje de tus hijos
          </p>
        </div>

        <div className="grid gap-8 max-w-5xl mx-auto lg:grid-cols-2">
          {/* Plan Gratuito */}
          <div className="relative bg-white border border-gray-200 rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="absolute top-4 right-4 bg-secondary/10 text-secondary text-xs sm:text-sm font-medium px-3 py-1 rounded-full">
              7 días gratis
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-primary mb-4">Plan Free</h3>
            <div className="flex items-baseline mb-2">
              <DollarSign className="h-5 w-5 md:h-6 md:w-6 text-gray-600" />
              <span className="text-3xl md:text-4xl font-bold text-primary">0</span>
              <span className="text-sm md:text-base text-gray-500 ml-2">/ 7 días</span>
            </div>
            <div className="mb-8">
              <span className="text-gray-500 text-sm line-through">
                <DollarSign className="h-3 w-3 inline-block" />
                10/mes
              </span>
              <span className="ml-2 text-secondary text-sm">
                ¡Prueba gratuita!
              </span>
            </div>
            <ul className="space-y-4 mb-8">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center">
                  {index < 4 ? (
                    <Check className="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                  ) : (
                    <X className="h-5 w-5 text-gray-400 mr-3 flex-shrink-0" />
                  )}
                  <span className={`${index >= 4 ? "text-gray-400" : "text-gray-600"} text-sm md:text-base`}>
                    {feature}
                  </span>
                </li>
              ))}
            </ul>
            <Button 
              className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white"
              onClick={() => navigate('/register')}
            >
              Comenzar prueba gratuita
            </Button>
          </div>

          {/* Plan Premium */}
          <div className="relative bg-gradient-to-br from-primary via-primary/95 to-primary rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-xl transition-shadow">
            <div className="absolute top-4 right-4 bg-secondary text-white text-xs sm:text-sm font-medium px-3 py-1 rounded-full">
              Más popular
            </div>
            <div className="absolute top-14 right-4 bg-orange-500 text-white text-xs sm:text-sm font-medium px-3 py-1 rounded-full">
              {discountPercentage}% OFF
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4">Plan Premium</h3>
            <div className="flex items-baseline mb-2">
              <DollarSign className="h-5 w-5 md:h-6 md:w-6 text-white/90" />
              <span className="text-3xl md:text-4xl font-bold text-white">{discountedPrice}</span>
              <span className="text-sm md:text-base text-white/80 ml-2">/ mes</span>
            </div>
            <div className="mb-8">
              <span className="text-white/70 text-sm line-through">
                <DollarSign className="h-3 w-3 inline-block" />
                {originalPrice}/mes
              </span>
              <span className="ml-2 text-secondary text-sm">
                ¡Precio promocional!
              </span>
            </div>
            <ul className="space-y-4 mb-8">
              {features.map((feature, index) => (
                <li key={index} className="flex items-center">
                  <Check className="h-5 w-5 text-secondary mr-3 flex-shrink-0" />
                  <span className="text-sm md:text-base text-white/90">{feature}</span>
                </li>
              ))}
            </ul>
            <Button 
              className="w-full bg-secondary hover:bg-secondary/90 text-white"
              onClick={() => navigate('/register')}
            >
              Comenzar prueba gratis
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};